<template>
    <div class="pmtdiv">
        <smallbutton toplabel="Receipt" @click="start()"  :buttonclass="buttonClass" v-if="showButton"/>
      
        <!--  MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform" v-if="thisticket!=null">
                    
                    <label class="titlelabel">Receipt for Ticket {{thisticket.id }}</label>
                    <br/>
                    <br></br>
                    <div class="actiondiv">
                        <label for="emailaddress" class="receiptlabel">Email Receipt to </label>
                        <input id="emailaddress" type="text" v-model="emailAddress" class="receiptinput">
                        <smallbutton  @click="sendEmail" toplabel="Send" :disabled="noEmail" buttonclass=" smbutton" v-if="!useDirectReceiptPrint"/>
                        <smallbutton  @click="sendEmail_htmlreceipt" toplabel="Send" :disabled="noEmail" buttonclass=" smbutton" v-if="useDirectReceiptPrint"/>
                        
                    </div>
                    
                    
                    <div v-if="receiptTextAvailable" class="actiondiv">
                        <label for="phonenumber" class="receiptlabel">Text Receipt to </label>
                        <input id="phonenumber" type="text" v-model="phoneNumber" class="receiptinput">
                        <smallbutton  @click="sendText" toplabel="Send" :disabled="noPhone" buttonclass=" smbutton"/>
                    </div>

                    
                    <div class="actiondiv">
                        <label class="receiptlabel">Print to Local Printer</label>
                        <label class=""></label>
                        <button ref="printthereceipt2" class="smbutton" type="button" @click="printMyReceipt" v-if="!useDirectReceiptPrint">Print</button>
                        <!-- <button ref="printthereceipt2" class="smbutton" type="button" v-print="'#receiptdatadiv2'" v-if="!useDirectReceiptPrint">Print</button>-->
                        <button ref="printthereceiptdirect" class="smbutton" type="button" v-if="useDirectReceiptPrint" @click="printMe()">Print</button> 
                    </div>
                    
                    
          
                    <smallbutton  @click="closeme" toplabel="Close" buttonclass="closebutton"/>
                    <div>
                        <label class="responsemessage">{{message}}</label>
                    </div>

                    <div v-show="false">
                        <div   id="receiptdatadiv2" v-show="receiptData!=null" >
                            <div class="receiptclass">{{receiptData}}</div>
                        </div>
                    </div>
                </form>
                
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import datamethods from '../../services/datamethods.js'
    import actionmodal from '../controls/actionmodal.vue'
    import pos from '../../services/pos.js'
    import pay from '../../services/pay.js'
    import print from 'vue-print-nb'
    import printreceipthelper from '../../services/printreceipthelper.js'
    export default {
        name:'receiptoptions',
        components:{
            smallbutton,
            linkbutton,
            actionmodal
        },
        directives:{
            print
        },
        props:{
            
            showButton:{
                type:Boolean,
                default:false
            },
       
            buttonClass:{
                type:String,
                default:'button buttonprimary bottom10'
            }
            
        },
        mixins:[format, datamethods,pos,printreceipthelper,pay],
        data(){
            return{
                message:null,
                guestNumber:null,
                thisticket:{},
                name:'Detail',
                trueParam:true, 
                emailAddress:null,
                phoneNumber:null,
                receiptPrintJob:{},
                


                receiptPrinterJob:{
                    ip:'192.168.0.22',
                    //ip:'localhost:8008',
                    printLines:[
                    {
                        alignment:'center',
                        isBold:true,
                        textSize:2,
                        text:'Test Institution'
                    },
                    {
                        alignment:'center',
                        isBold:true,
                        text:'Test Location'
                    },
                    {
                        alignment:'center',
                        text:'123 Easy Street'
                    },
                    {
                        alignment:'center',
                        text:'Mountain Home, ID 83647'
                    },
                    {
                        alignment:'center',
                        text:'123-456-7890'
                    },
                    {
                        isSpace:true
                    },
                    {
                        alignment:'center',
                        text:'12/15/2025'
                    },
                    {
                        alignment:'center',
                        text:'Ticket # 12345'
                    },
                    {
                        isSpace:true
                    },
                    {
                        text:'Customer Name: Joe Shmo'
                    },
                    {
                        text:'Served by: Fred Flinstone'
                    },
                    {
                        isSpace:true
                    },
                    {
                        text:'1234   Bagel   $5.00',
                        indent:30,
                    },
                    {
                        text:'Discount       $1.00',
                        indent:30,
                    },
                    {
                        isSpace:true
                    },
                    {
                        text:'Subtotal:      $4.00'
                    },
                    {
                        text:'Tax:           $0.24'

                    },
                    {
                        Total:'Total:        $4.24'
                    },
                    {
                        isSpace:true
                    },
                    {
                        text:'Payment: Cash  $5.00'
                    },
                    {
                        text:'Change given:  $0.76'
                    },
                    {
                        isSpace:true
                    },
                    {
                        text:'Ticket Status: Completed'
                    },
                    {
                        text:'Customer Copy'
                    },
                    {
                        isSpace:true
                    },
                    {
                        text:'Return/Refund policy'
                    },
                    {
                        isSpace:true
                    },
                    {
                        text:'Required CC stuff'
                    },
                    {
                        isSpace:true
                    },
                    {
                        /* alignment:'center',
                        image:'schoolvision.jpg', */
                        doFeed:true,
                        doCut:true
                    }
                    ]
                } 


               

            }
        },
        computed:{
            ...mapFields([
                'pleaseWait',
           
         
            ]),
            noEmail(){
                return this.emailAddress==null || this.emailAddress==''
            },
            noPhone(){
                return this.phoneNumber==null || this.phoneNumber==''
            },
            

        },
        methods:{
            async printMe(){
                if(this.guestNumber==null){ //whole receipt
                   // console.log('receiptoptionspopup: print whole')
                    this.receiptPrintJob = await this.printReceiptDirectForCurrentTicket(null,this.thisticket)
                    this.printReceiptDirect(this.receiptPrintJob)
                    if(this.autoOpenCashDrawer()){this.openCashDrawer()}
                }else{//by gnumber
                   // console.log('receiptoptionspopup: print for guest ' + this.guestNumber)
                    this.receiptPrintJob = await this.printReceiptDirectForCurrentTicket(this.guestNumber,this.thisticket)
                    this.printReceiptDirect(this.receiptPrintJob)
                    if(this.autoOpenCashDrawer()){this.openCashDrawer()}
                }
                
            },

            //old way
            printMyReceipt() {
                    const contentEl = document.getElementById('receiptdatadiv2')

                    if (!contentEl) {
                    console.error('Receipt element not found')
                    return
                    }

                    const printWindow = window.open('', '', 'width=800,height=600')

                    printWindow.document.write(`
                    <html>
                        <head>
                        <title>Receipt</title>
                        <style>
                            body {
                            font-family: monospace;
                            font-size: 12px;
                            margin: 0;
                            padding: 10px;
                            }

                            .receipt {
                            width: 100%;
                            }

                            .center {
                            text-align: center;
                            }

                            .row {
                            display: flex;
                            justify-content: space-between;
                            }

                            hr {
                            border: none;
                            border-top: 1px dashed #000;
                            margin: 8px 0;
                            }
                            .receiptclass{
                                margin-top:120px;
                                white-space: pre-wrap;
                            } 
                        </style>
                        </head>
                        <body>
                        ${contentEl.outerHTML}
                        </body>
                    </html>
                    `)

                    printWindow.document.close()

                    // small delay ensures content renders before print dialog
                    printWindow.focus()
                    setTimeout(() => {
                    printWindow.print()
                    printWindow.close()
                    }, 300)
                },


            closeme(){
                this.$emit('close')
                this.$refs.mymodal.closeModal()
            },
           
            
            start(gNumber=null, t=null){
               // console.log('ticket ' + t)
                this.guestNumber=gNumber
                if(t!=null){
                    this.thisticket=t
                }
                
                if(this.guest==null){
                    this.emailAddress=null
                    this.phoneNumber=null
                }
                else if(this.guest.EmailAddress==undefined){
                    this.emailAddress=null
                    this.phoneNumber=null
                }
                else if(this.guest.EmailAddress.includes('WalkInGuest')){
                    this.emailAddress=null
                    this.phoneNumber=null
                }else{
                    this.emailAddress=this.guest.EmailAddress
                    this.phoneNumber=this.guest.PhoneNumber
                }
                
                
                this.getReceiptData()
                this.$refs.mymodal.openModal()
            },
            async sendEmail(){
                console.log('email receipt!')
                let req = {
                    emailAddress:this.emailAddress,
                    subject:'Receipt',
                    body:this.receiptData

                }  
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'sendemail')
                //handle response
            
                if(response.Successful){
                    //this.receiptData=response.StringResponse
                    this.pleaseWait=false;
                    //this.receipt() //print!
                    this.message = "Email Sent"
                    
                }else{
                    this.message = response.Message
                }
                this.pleaseWait=false;
            },
            async sendEmail_htmlreceipt(){
                console.log('email receipt!')
                let req = {
                    emailAddress:this.emailAddress,
                    subject:'Receipt',
                    body:this.receiptData,
                    ticketId:this.thisticket.id,
                    guestNumber:this.guestNumber

                }  
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'sendemail_receipt')
                //handle response
            
                if(response.Successful){
                    //this.receiptData=response.StringResponse
                    this.pleaseWait=false;
                    //this.receipt() //print!
                    this.message = "Email Sent"
                    
                }else{
                    this.message = response.Message
                }
                this.pleaseWait=false;
            },
            sendText(){
                console.log('text receipt!')
            },
            async getReceiptData(autoreceipt=false){
                let req = {
                    ticket:{
                        id:this.thisticket.id
                    }
                }  
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'ticketreceipt')
              //handle response
          
              if(response.Successful){
                this.receiptData=response.StringResponse
                this.pleaseWait=false;
                //this.receipt() //print!
                
                
              }else{
                this.message = response.Message
              }
              this.pleaseWait=false;
        },
           
                
        }
    }
    
    </script>
    
    <style>
    .smbutton{
        color:var(--button-text-color);
    border: none;
    border-radius:10px;
    width:60px;
    height:30px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
  background-color:var( --button-color);
}
.closebutton{
        color:var(--button-text-color);
    border: none;
    border-radius:10px;
    width:100px;
    height:40px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
  background-color:var( --button-color);
}
.actiondiv{
    display:grid;
    grid-template-columns: 2fr 2fr 1fr;
    text-align: left;
    vertical-align:middle;
    height:40px;
    margin:5px;

}
.receiptinput{
    height:30px;
    margin:10px;
}

.receiptlabel{
    margin:10px;
}
    </style>
    
    
  
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    